import React from "react";
import "./index.css";
import resilientFund from "../../assets/resilientFund.webp";
import operate1 from "../../assets/operate1.webp";
import operate2 from "../../assets/operate2.webp";
import operate3 from "../../assets/operate3.webp";
import operate4 from "../../assets/operate4.webp";

const ResilientFund = () => {
  return (
    <div className="resilient-fund">
      {/* Header Section */}
      <div className="img-container">
        <img className="about-image1" src={resilientFund} alt="About Us" />
        <div class="text-overlay">Capri Stressed Assets Fund</div>
      </div>
      <div className="heading">
        Our fund investment thesis envisages participation in the value creation
        process while aiming to preserve the invested capital.
      </div>

      {/* Hybrid Structure Section */}
      <section className="hybrid-structure">
        <h2>Hybrid Structure</h2>
        <div className="hybrid-content">
          <div className="part">
            <div className="circle">
              <h3>Debt</h3>
            </div>
            <p>Downside Protection</p>
          </div>
          <div className="part">
            <div className="plus">+</div>
          </div>
          <div className="part">
            <div className="circle">
              <h3>Equity Options / Equity</h3>
            </div>
            <p>Upside Participation</p>
          </div>
        </div>

        <div className="process-flow">
          <div className="timeline">
            <div className="circle"></div>
            <div className="line"> </div>
            <div className="block">Invest</div>
            <div className="circle"></div>
            <div className="line"></div>
            <div className="block">Growth & Turnaround</div>
            <div className="circle"></div>
            <div className="line"></div>
            <div className="block">Exit</div>
            <div className="circle"></div>
          </div>
        </div>

        <div className="process-flow">
          <div className="process-container">
            <div className="vertical-label">Solve for</div>
            <div className="boxes">
              <div className="box">Capital Structure</div>
              <div className="box">Rationalize Operations</div>
              <div className="box">Corporate Governance</div>
            </div>
          </div>

          <div className="process-container">
            <div className="vertical-label">Harvest Cash</div>
            <div className="boxes">
              <div className="box">Sustainable Debt at Current Pay</div>
              <div className="box">Recover Majority of Invested Capital</div>
              <div className="box">Value Creation</div>
            </div>
          </div>

          <div className="process-container">
            <div className="vertical-label">Exit</div>
            <div className="boxes">
              <div className="box">Refinance of Debt</div>
              <div className="box">IPO</div>
              <div className="box">Strategic Sale</div>
            </div>
          </div>
        </div>
      </section>

      {/* Operations Section */}
      <section className="operations">
        <h2>How Do We Operate?</h2>
        <div className="operation-cards">
          <div className="card">
            <div className="card-icon">
              <img src={operate1} alt="icon" />
            </div>
            <p className="card-description">
              Designed to be significant equity-oriented, we believe in value
              investing in scalable businesses facing capital issues with
              demonstrated past track records.
            </p>
          </div>
          <div className="card">
            <div className="card-icon">
              <img src={operate2} alt="icon" />
            </div>
            <p className="card-description">
              We seek to work with promoters who have demonstrated unwavering
              commitment and are receptive to implementing a focused resurgence
              strategy. We recognise that every business and transaction is
              unique in nature.
            </p>
          </div>
          <div className="card">
            <div className="card-icon">
              <img src={operate3} alt="icon" />
            </div>
            <p className="card-description">
              Our investments are specifically engineered to provide a holistic
              solution to each of our portfolio companies, and are predominantly
              structured through a combination of debt and significant equity.
            </p>
          </div>
          <div className="card">
            <div className="card-icon">
              <img src={operate4} alt="icon" />
            </div>
            <p className="card-description">
              The debt structure provides downside risk protection and an avenue
              to seek progressive returns on investments from cash flows.
            </p>
          </div>
        </div>
      </section>

      {/* Contribution Section */}
      <section className="contribution">
        <h2>How Do We Contribute?</h2>
        <h3>
          We develop a fundamentally strong working relationship with promoters
          and management to ensure that a strong resurgence strategy is
          effectively implemented.
        </h3>
        <h4>
          <b>We work actively with the management of investee entities in:</b>
        </h4>
        <div className="steps">
          <div className="step">
            <h3>01</h3>
            <div className="half-circle">
              <p>Formulating a comprehensive turnaround plan.</p>
            </div>
          </div>
          <div className="step">
            <h3>02</h3>
            <div className="half-circle">
              <p>
                Identifying ways to improve the key financial levers of a
                business.
              </p>
            </div>
          </div>
          <div className="step">
            <h3>03</h3>
            <div className="half-circle">
              <p>
                Upgrading existing internal controls, systems, and processes.
              </p>
            </div>
          </div>
          <div className="step">
            <h3>04</h3>
            <div className="half-circle">
              <p>
                Strengthening corporate governance and improving management.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Value Section */}
      <section className="value">
        <h2>How Do We Add Value To Our Investors?</h2>
        <p>
          Our primary aim is to provide our portfolio companies with a
          sustainable capital solution — one that enables them to scale their
          operations with minimal additional support. We seek to accomplish this
          objective by engineering an optimised investment structure that
          specifically caters to each portfolio company's individual
          requirements.
        </p>
        <p>
          We seek to recover invested capital through the company's cash flows,
          while actively creating an exit for our equity holding in the company.
        </p>
      </section>
    </div>
  );
};

export default ResilientFund;
